import { Divider } from "antd";
import { DisplayWidth } from "./DisplayWidth.tsx";
import "./AppSettingsContent.scss";
import { useIntl } from "react-intl";
import { Logout } from "./Logout.tsx";

export const AppSettingsContent = () => {
  const {formatMessage} = useIntl();
  return (
    <div className="app-settings-content">
      <div className="app-settings-content-title">{formatMessage({id: 'app.settings.title'})}</div>
      <Divider />
      <DisplayWidth />
      <Divider />
      <Logout />
    </div>
  )
}